const ListSvg = () => {
    return(
        <svg className='list-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 509 384'>
           <path d='M47.5,65A45.5,45.5,0,1,1,2,110.5,45.5,45.5,0,0,1,47.5,65Zm0,146A45.5,45.5,0,1,1,2,256.5,45.5,45.5,0,0,1,47.5,211Zm0,146A45.5,45.5,0,1,1,2,402.5,45.5,45.5,0,0,1,47.5,357ZM172,356H469a42,42,0,0,1,42,42v8a42,42,0,0,1-42,42H172a42,42,0,0,1-42-42v-8A42,42,0,0,1,172,356Zm0-146H469a42,42,0,0,1,42,42v8a42,42,0,0,1-42,42H172a42,42,0,0,1-42-42v-8A42,42,0,0,1,172,210Zm0-146H469a42,42,0,0,1,42,42v8a42,42,0,0,1-42,42H172a42,42,0,0,1-42-42v-8A42,42,0,0,1,172,64Z' transform='translate(-2 -64)'/>
        </svg>
    )
}

export default ListSvg